@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px; padding-left: 1em; padding-right: 1em; padding-top: 1em">
    <h3 style="margin: 0">Urit</h3>
    <div>
      Päätilikartta: <a [href]="paatilikarttaEncodedUriObservable | async" target="_BLANK">{{ paatilikarttaUriObservable | async }}</a>
    </div>
    <div>
      Asiakkaan tilikartta: <a [href]="asiakkaanTilikarttaEncodedUriObservable | async" target="_BLANK">{{ asiakkaanTilikarttaUriObservable | async }}</a>
    </div>
  </div>
}

<div style="display: flex; justify-content: space-between; flex-flow: row; align-items: center; margin-bottom: 10px">
  <div style="width: 75px">
    <mat-select placeholder="Kieli" [formField]="lomake.kieli" (selectionChange)="kieliMuuttui($event)" style="width: 100%">
      <mat-option value="fi">Suomi</mat-option>
      <mat-option value="en">Englanti</mat-option>
    </mat-select>
  </div>
  <div style="width: 150px">
    <mat-select placeholder="Tilikartta" [formField]="lomake.profiili" (selectionChange)="profiiliMuuttui($event)" style="width: 100%">
      <mat-option [value]="'maksuperusteinen'">Kevyt</mat-option>
      <mat-option [value]="'liikekirjuri'">Liikekirjuri</mat-option>
    </mat-select>
  </div>
</div>

@if (commonError) {
  <div class="error-text">{{ commonError }}</div>
}

@if (loading()) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="example-list" [class.hidden]="loading()">
  @for (node of flatatyt | async; track node) {
    <div [class.dark-gray-text]="5 > node.kirjanpitotili.numero.length" class="example-box" [style.padding-left]="node.level * 15 + 'px'" style="cursor: default">
      {{ node.name }}
    </div>
  }
</div>
